import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  CheckCircleOutlined,
  RightOutlined,
  LeftOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { Empty } from "antd";
import GemoWorkDoneModal from "./GemoWorkDoneModel";
import ReactPaginate from "react-paginate";
import { useGetArizaNotFinishedQuery } from "../../redux/gemo/gemo";
import GemoExel from "./ExelGemo";

function GemoMed() {
  const [page, setPage] = useState(0);
  const { data, isLoading } = useGetArizaNotFinishedQuery(page);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [id, setId] = useState({});

  const columns = [
    {
      title: "No",
    },
    {
      title: "ID",
    },
    {
      title: "Muammo",
    },
    {
      title: "Bo`lim",
    },
    {
      title: "Xona",
    },
    {
      title: "Ism",
    },
    {
      title: "Familiya",
    },
    {
      title: "Tel nomer",
    },
    {
      title: "Sana",
    },
    {
      title: "Vaqti",
    },
    {
      title: "",
    },
  ];

  const handleOpenModal = (id) => {
    setIsModalOpen(true);
    setId(id);
  };

  return (
    <div>
      <GemoExel />
      <GemoWorkDoneModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        id={id}
      />
      <Table id="table-to-xls" striped bordered hover>
        <thead>
          <tr>
            {columns?.map((item, index) => (
              <th key={index}>{item.title}</th>
            ))}
          </tr>
        </thead>

        {isLoading ? (
          <h1>Loading......</h1>
        ) : data?.totalPage === 0 ? (
          <Empty />
        ) : (
          <tbody>
            {data?.list?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item?.code}</td>
                <td width={400}>{item?.problem}</td>
                <td width={400}>{item?.department}</td>
                <td>{item?.roomNumber}</td>
                <td width={110}>{item?.surname}</td>
                <td width={110}>{item?.name}</td>
                <td>{item?.phoneNumber}</td>
                <td>{item?.createdAt.slice(0, 10)}</td>
                <td>{item?.createdAt.slice(11, 16)}</td>
                <td>
                  {
                    <CheckCircleOutlined
                      onClick={handleOpenModal.bind(null, {
                        id: item.code,
                        name: item.name + " " + item.surname,
                      })}
                      style={{
                        fontSize: "22px",
                        color: "green",
                        fontWeight: "bold",
                      }}
                    />
                  }
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </Table>

      <ReactPaginate
        breakLabel="..."
        nextLabel={<RightOutlined />}
        onPageChange={(pag) => setPage(pag.selected)}
        pageRangeDisplayed={5}
        pageCount={data?.totalPage}
        previousLabel={<LeftOutlined />}
        renderOnZeroPageCount={null}
        className="pagination"
        activeClassName="active"
      />
    </div>
  );
}

export default GemoMed;
